export class ApiClientError extends Error {
	constructor(cause?: unknown) {
		const causeMessage =
			cause instanceof Error ? cause.message : String(cause ?? 'Unknown error');

		super(`ApiClient Error: ${causeMessage}`);
		this.name = 'ApiClientError';
		this.cause = cause;
	}
}
